import { useSelector } from 'react-redux'
import { LANDING_TYPE, SURVEY_EMAIL_TYPE, SURVEY_TYPE } from '../constants/features'

export const useIsLandingProject = () =>
  useSelector((state) => state.getIn(['project', 'ProjectType'], 'web') === LANDING_TYPE)
export const useIsSurveyLikeProject = () =>
  useSelector((state) => [SURVEY_TYPE, SURVEY_EMAIL_TYPE].includes(state.getIn(['project', 'ProjectType'], 'web')))
export const useIsSurveyEmailProject = () =>
  useSelector((state) => state.getIn(['project', 'ProjectType'], 'web') === SURVEY_EMAIL_TYPE)
